export const TooltipComments = ({ result }) => {
  /* const { combineInfo } = result; */

  return (
    <>
      <div
        className="absolute right-full top-1/2 transform -translate-y-1/2 mr-2 z-50 
             w-max bg-gray-900 text-white text-sm rounded py-1 px-2
             opacity-0 group-hover:opacity-100 transition-opacity duration-300
             pointer-events-none"
      >
        {/* Arrow pointing right */}
        <div
          className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-full w-0 h-0
               border-t-4 border-t-transparent border-b-4 border-b-transparent
               border-l-4 border-l-gray-900"
        ></div>
        <p className="text-xs"> {result} </p>
      </div>
    </>
  );
};
